module.exports = __webpack_public_path__ + "fonts/iconfont.3e71505.woff2";